import api from "./api";

// Quantitative flow analysis (FBPM Ch.7) — cycle time, CTE, cost.

/** Flow-analysis metrics for a process (cycle time, value-adding time, CTE, cost). */
export async function getFlowAnalysis(processId) {
  return api.get(`/process/${processId}/flow-analysis`);
}

/** Set XOR/inclusive branch probabilities. `items` = [{ branch_pk_id, probability|null }]. */
export async function saveBranchProbabilities(processId, items) {
  return api.patch(`/process/${processId}/flow-analysis/probabilities`, { items });
}

/**
 * TO-BE candidate scoring — the SAME canonical engine the agent's scenarios use.
 * Used by the Analyze tab's selective reassignment apply: the chosen subset of
 * job swaps is re-scored by the backend (never client-side math).
 *
 * `body` fields (all optional, whitelisted by the backend DTO):
 *  - base_on_stored_gateways: keep the AS-IS branching, treat candidates as deltas
 *  - exclude_task_ids: activity elimination (the active scenario's set)
 *  - resource_overrides: [{ task_id, job_id, replace_job_id, role }]
 */
export async function whatIfFlowAnalysis(processId, body) {
  return api.post(`/process/${processId}/flow-analysis/what-if`, body || {});
}
